import React, { useState, useEffect } from 'react';
import { Snackbar, Alert } from '@mui/material';
import BuildingForm from '../components/BuildingForm';
import axios from 'axios';

const EditBuilding = ({ building, onClose, onSuccess, onError }) => {
    const [formData, setFormData] = useState(null);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

    useEffect(() => {
        if (building) {
            setFormData({ ...building });
        }
    }, [building]);

    const handleEditBuilding = (payload) => {
        axios.put(`/buildings/${building.id}/`, payload)
            .then(() => {
                setSnackbar({ open: true, message: 'Building updated successfully!', severity: 'success' });
                onSuccess();
                onClose();
            })
            .catch(() => {
                setSnackbar({ open: true, message: 'Failed to update building.', severity: 'error' });
                onError();
            });
    };

    if (!formData) return null;

    return (
        <>
            <BuildingForm
                initialValues={formData}
                onSubmit={handleEditBuilding}
                onCancel={onClose}
                submitLabel="Save"
                isEdit={true}
            />
            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            >
                <Alert
                    onClose={() => setSnackbar({ ...snackbar, open: false })}
                    severity={snackbar.severity}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </>
    );
};

export default EditBuilding;
